export const formatTwelveHour = (date) => {
    if (!date) return ""
    let newDate = new Date(date)
    let hours = newDate.getHours().toString().padStart(2, '0')
    let mins = newDate.getMinutes().toString().padStart(2, '0')
    let suffix = hours >= 12 ? 'PM' : 'AM'
    hours %= 12
    hours = hours ?? 12; // Convert 0 to 12 for 12hour clock
    return `${hours}:${mins} ${suffix}`
}